import { getToken } from '@/keycloak'

export const authenticatedPost = async (url, body) => fetch(url, {
  method: 'POST',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + await getToken()
  },
  body: JSON.stringify(body)
}).then(it => new Promise((resolve, reject) => it.status < 400 ? resolve(it) : reject(it)))
